"use client";

import React from "react";
import { CaseStudyData } from "../../data/case-studies/types";

interface CaseStudyContextProps {
  caseStudy: CaseStudyData;
}

export function CaseStudyContext({ caseStudy }: CaseStudyContextProps) {
  return (
    <section className="py-24 md:py-36 border-b border-white/[0.08]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          
          {/* Left 5 Cols: Monumental Statement & Thesis */}
          <div className="lg:col-span-5 space-y-6">
            <span className="block font-mono text-xs uppercase tracking-wider text-zinc-500">
              The Challenge
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-[2.75rem] font-light text-white leading-tight tracking-tight">
              &ldquo;{caseStudy.challenge.statement}&rdquo;
            </h2>
          </div>

          {/* Right 7 Cols: Context Prose & Numbered Breakdown */}
          <div className="lg:col-span-7 space-y-12">
            
            {/* Narrative Context */}
            <div className="space-y-6 text-base sm:text-lg text-zinc-400 font-light leading-relaxed">
              {caseStudy.challenge.context.map((paragraph, pIdx) => (
                <p key={pIdx}>{paragraph}</p>
              ))}
            </div>

            {/* Failure Modes (Pure Swiss Numbered List with 1px Hairlines) */}
            <div className="pt-8 border-t border-white/[0.08] space-y-6">
              <span className="block font-mono text-xs uppercase tracking-wider text-zinc-500">
                Legacy System Bottlenecks
              </span>

              <div className="divide-y divide-white/[0.08]">
                {caseStudy.challenge.failurePoints.map((point, idx) => (
                  <div key={idx} className="py-5 flex items-start gap-6 group">
                    <span className="font-mono text-xs text-zinc-600 group-hover:text-zinc-400 transition-colors pt-0.5 shrink-0">
                      0{idx + 1}
                    </span>
                    <p className="text-sm sm:text-base text-zinc-300 font-light leading-relaxed">
                      {point}
                    </p>
                  </div>
                ))}
              </div>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
}
